import React from "react";
import { ClipboardListIcon } from "@heroicons/react/solid";

const Resume = () => {
    return (
        <div id="Resume" className="lg:w-4/5 mt-24 mx-12 lg:ml-24 mb-96">
            <div>
                <div className="table">
                    <ClipboardListIcon className="h-5 w-5 mr-4 text-yellow_vs" />{" "}
                    <code className="table-cell text-[#e6f1ff] text-3xl mt-5 whitespace-nowrap">
                        Resume
                    </code>
                    <div className="table-cell border-b border-b-[#e6f1ff] border-opacity-25 w-full"></div>
                </div>
            </div>
            <div className="text-[#a2aabc] text-lg mt-5">
                <div className="flex flex-col md:flex-row gap-4 md:gap-0">
                    <div className="w-1/4">
                        <code className="text-yellow_vs text-2xl">
                            Education
                        </code>
                    </div>
                    <div className="md:w-3/4">
                        <code className="text-blue_vs text-2xl">
                            Jacksonville State University
                        </code>
                        <br />
                        <code className="italic text-m text-lightblue_vs">
                            Masters of Science in Computer Systems and Software
                            Design
                        </code>
                        <br />
                        <code className="text-s text-brown_vs">
                            • January 2020 - May 2021 Graduated with 4.0 GPA
                        </code>
                        <br />
                        <code className="italic text-m text-lightblue_vs">
                            Bachelors of Science in Computer Science
                        </code>
                        <br />
                        <code className="text-s text-brown_vs">
                            • August 2015 - December 2018 Graduated with 3.8 GPA
                        </code>
                    </div>
                </div>
                <div className="flex flex-col pt-10 md:flex-row gap-4 md:gap-0">
                    <div className="w-1/4">
                        <code className="text-yellow_vs text-2xl">Work</code>
                    </div>
                    <div className="md:w-3/4">
                        <code className="text-blue_vs text-2xl">
                            Leidos Dynetics
                        </code>
                        <br />
                        <code className="italic text-m text-lightblue_vs">
                            Huntsville, AL{" "}
                        </code>
                        <br />
                        <code className="text-s text-brown_vs">
                            • May 2021 - Present
                        </code>
                        <br />
                        <code className="text-m">
                            <br />• Software Engineer for Unmanned Aerial
                            Systems Arbitration Suite which provides command and
                            control functionality to several air platforms
                            through our API.
                            <br />• Develop custom Web Clients, API testing
                            tools, along with Android Tactical Assault Kit
                            plugins to interface with Arbitration Suite's API.
                            <br />• Android Development in support of DARPA's
                            Mobile Force Protection project.
                        </code>
                        <br />
                        <br />
                        <code className="text-blue_vs text-2xl">
                            Yamato Steakhouse
                        </code>
                        <br />
                        <code className="italic text-m text-lightblue_vs">
                            Jacksonville, AL{" "}
                        </code>
                        <br />
                        <code className="text-s text-brown_vs">
                            • January 2019 - Present
                        </code>
                        <br />
                        <code className="text-m">
                            <br />• I developed and maintained an online
                            ordering system for a local restaurant. This
                            involved designing the user interface, ensuring the
                            functionality of the website, and integrating
                            third-party APIs to facilitate phone calls, text
                            messages, and email notifications. I also repurposed
                            an existing iPad for email order notifications.
                            <br />• During the pandemic, I played an
                            instrumental role in helping the restaurant continue
                            their business operations by delivering a reliable
                            and efficient online ordering platform. By
                            collaborating effectively with the management team,
                            I was able to expand the restaurant's customer base
                            and increase revenue, despite the challenging
                            circumstances.
                        </code>

                        <br />
                        <br />
                        <code className="text-blue_vs text-2xl">
                            Graduate Teaching Assistant
                        </code>
                        <br />
                        <code className="italic text-m text-lightblue_vs">
                            Jacksonville, AL{" "}
                        </code>
                        <br />
                        <code className="text-s text-brown_vs">
                            • January 2021 - May 2021
                        </code>
                        <br />
                        <code className="text-m">
                            <br />• During my last semester of graduate school.
                            I worked as a Graduate Teaching Assistant at
                            Jacksonville State University. In this capacity, I
                            provided valuable support to Computer Science and
                            Mathematics faculty members by facilitating student
                            learning through individual and group tutoring
                            sessions, as well as assessing their academic
                            progress by grading papers. This role not only
                            allowed me to hone my teaching and mentoring skills
                            but also enabled me to make meaningful contributions
                            towards the academic development of the university's
                            students.
                        </code>
                    </div>
                </div>
                <div className="flex flex-col pt-10 flex-wrap md:flex-row">
                    <div className="w-1/4">
                        <code className="text-yellow_vs text-2xl">Skills</code>
                    </div>
                    <div className="md:w-3/4">
                        <p className="text-m font-mono">
                            <br />• I speak Latin :)
                            <br />• Lorem ipsum dolor sit amet, consectetur
                            adipiscing elit, sed do eiusmod tempor incididunt ut
                            labore et dolore magna aliqua. Ut enim ad minim
                            veniam, quis nostrud exercitation ullamco laboris
                            nisi ut aliquip ex ea commodo consequat. Duis aute
                            irure dolor in reprehenderit in voluptate velit esse
                            cillum dolore eu fugiat nulla pariatur. Excepteur
                            sint occaecat cupidatat non proident, sunt in culpa
                            qui officia deserunt mollit anim id est laborum.
                            <br />
                            <code className="italic text-m text-lightblue_vs">
                                C# and .NET Framework
                            </code>
                            <p>
                                • Lorem ipsum dolor sit amet, consectetur
                                adipiscing elit, sed do eiusmod tempor
                                incididunt ut labore et dolore magna aliqua. Ut
                                enim ad minim veniam, quis nostrud exercitation
                                ullamco laboris nisi ut aliquip ex ea commodo
                                consequat. Duis aute irure dolor in
                                reprehenderit in voluptate velit esse cillum
                                dolore eu fugiat nulla pariatur. Excepteur sint
                                occaecat cupidatat non proident, sunt in culpa
                                qui officia deserunt mollit anim id est laborum.
                            </p>
                            <br />
                            <code className="italic text-m text-lightblue_vs">
                                WireShark
                            </code>
                            <p>
                                • Lorem ipsum dolor sit amet, consectetur
                                adipiscing elit, sed do eiusmod tempor
                                incididunt ut labore et dolore magna aliqua. Ut
                                enim ad minim veniam, quis nostrud exercitation
                                ullamco laboris nisi ut aliquip ex ea commodo
                                consequat. Duis aute irure dolor in
                                reprehenderit in voluptate velit esse cillum
                                dolore eu fugiat nulla pariatur. Excepteur sint
                                occaecat cupidatat non proident, sunt in culpa
                                qui officia deserunt mollit anim id est laborum.
                            </p>
                            <br />
                            <code className="italic text-m text-lightblue_vs">
                                Web Development Technologies
                            </code>
                            <p>
                                • Lorem ipsum dolor sit amet, consectetur
                                adipiscing elit, sed do eiusmod tempor
                                incididunt ut labore et dolore magna aliqua. Ut
                                enim ad minim veniam, quis nostrud exercitation
                                ullamco laboris nisi ut aliquip ex ea commodo
                                consequat. Duis aute irure dolor in
                                reprehenderit in voluptate velit esse cillum
                                dolore eu fugiat nulla pariatur. Excepteur sint
                                occaecat cupidatat non proident, sunt in culpa
                                qui officia deserunt mollit anim id est laborum.
                            </p>
                            <br />
                            <code className="italic text-m text-lightblue_vs">
                                Python
                            </code>
                            <p>
                                • Lorem ipsum dolor sit amet, consectetur
                                adipiscing elit, sed do eiusmod tempor
                                incididunt ut labore et dolore magna aliqua. Ut
                                enim ad minim veniam, quis nostrud exercitation
                                ullamco laboris nisi ut aliquip ex ea commodo
                                consequat. Duis aute irure dolor in
                                reprehenderit in voluptate velit esse cillum
                                dolore eu fugiat nulla pariatur. Excepteur sint
                                occaecat cupidatat non proident, sunt in culpa
                                qui officia deserunt mollit anim id est laborum.
                            </p>
                            <br />
                            <code className="italic text-m text-lightblue_vs">
                                Java and Android Development
                            </code>
                            <p>
                                • Lorem ipsum dolor sit amet, consectetur
                                adipiscing elit, sed do eiusmod tempor
                                incididunt ut labore et dolore magna aliqua. Ut
                                enim ad minim veniam, quis nostrud exercitation
                                ullamco laboris nisi ut aliquip ex ea commodo
                                consequat. Duis aute irure dolor in
                                reprehenderit in voluptate velit esse cillum
                                dolore eu fugiat nulla pariatur. Excepteur sint
                                occaecat cupidatat non proident, sunt in culpa
                                qui officia deserunt mollit anim id est laborum.
                            </p>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Resume;
